import { User } from "@/types/v2";

export const filterStyles = {
  container:
    "text-sm font-medium text-center text-gray-500 border-b border-secondary",
  list: "flex flex-wrap -mb-px",
  button: {
    base: "group inline-block p-4 border-b-2 border-transparent rounded-t-lg transition-all duration-200 cursor-pointer ring-1 ring-gray-200 hover:ring-gray-300 active:ring-gray-400 active:bg-gray-50 active:scale-[0.995] transform",
    default:
      "text-primary hover:text-primary/80 hover:border-secondary/50 active:text-primary/70",
    active:
      "text-white bg-primary shadow-sm hover:shadow-md hover:bg-primary/90 active:bg-primary/80",
  },
};

export const listStyles = {
  site: {
    container:
      "group p-4 my-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-200 cursor-pointer ring-1 ring-gray-200 hover:ring-gray-300 active:ring-gray-400 active:bg-gray-50 active:scale-[0.995] transform",
    link: "block p-4",
    wrapper: "flex items-center gap-5",
    iconWrapper: "shrink-0",
    icon: "w-8 h-8 text-gray-400 group-hover:text-gray-600 group-active:text-gray-700 transition-colors duration-200",
    title:
      "text-lg font-light tracking-tight text-gray-700 group-hover:text-gray-900 group-active:text-gray-800",
    arrow: {
      wrapper:
        "ml-auto text-gray-400 group-hover:text-gray-600 group-hover:translate-x-1 group-active:text-gray-700 group-active:translate-x-2 transition-all duration-200",
      icon: "h-5 w-5",
    },
  },

  task: {
    container:
      "group p-4 my-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-200 cursor-pointer ring-1 ring-gray-200 hover:ring-gray-300 active:ring-gray-400 active:bg-gray-50 active:scale-[0.995] transform", // Same as site container
    wrapper: "flex  justify-between items-center gap-5",
    contentWrapper: "flex items-center gap-5",
    iconWrapper: "shrink-0",
    icon: "w-5 h-5 text-gray-400 group-hover:text-gray-600 group-active:text-gray-700 transition-colors duration-200",
    title:
      "text-lg font-light tracking-tight text-gray-700 group-hover:text-gray-900 group-active:text-gray-800",
    statusBadge: "px-2.5 py-1 rounded-md text-sm font-medium",
    study:
      "ml-3 rounded-md text-xs bg-secondary px-2.5 py-1 text-white font-bold",
    meta: {
      wrapper: "flex items-center gap-4 text-gray-600",
      scheduledDate: "text-sm flex items-center gap-2",
    },
  },
};

export const getTaskStatusStyles = (
  status: string,
  currentUser: User | null,
  startedBy: string | null
) => {
  if (status === "finished") {
    return {
      badge: "bg-green-100 text-green-700 border border-green-200",
      text: "text-green-700",
    };
  }
  if (currentUser?.name === startedBy) {
    return {
      badge: "bg-blue-100 text-blue-700 border border-blue-200",
      text: "text-blue-700",
    };
  }
  if (
    currentUser?.name &&
    startedBy !== null &&
    currentUser.name !== startedBy
  ) {
    return {
      badge: "bg-orange-100 text-orange-700 border border-orange-200",
      text: "text-orange-700",
    };
  }
  return {
    badge: "bg-gray-100 text-gray-700 border border-gray-200",
    text: "text-gray-600",
  };
};

export const taskBorderStyle = {
  "border-right": "1px solid rgba(169, 169, 169, 0.098)",
  "border-top": "1px solid rgba(169, 169, 169, 0.098)",
  "border-bottom": "1px solid rgba(169, 169, 169, 0.098)",
};
